import { SAMLIdPModel } from 'models/saml-idp.model';

export class SAMLIdPToPublicSAMLIdP {
  /**
   * Remove sensitive fields from IdP.
   */
  public transform(idp: SAMLIdPModel, auth: Auth): PublicSAMLIdPModel {
    if (auth.level === 'root') {
      return idp;
    }

    return {
      entityID: idp.entityID,
      emailDomain: idp.emailDomain,
      attributeMap: idp.attributeMap,
    };
  }
}

export type PublicSAMLIdPModel = Partial<SAMLIdPModel>;
export const DEFAULT_SAML_ORGANIZATION = 'None';
export const samlIdPToPublicSAMLIdP = new SAMLIdPToPublicSAMLIdP();

export default samlIdPToPublicSAMLIdP;
